const __WEBPACK_NAMESPACE_OBJECT__ = require("plugin-joblog/shared/lib/frac-events-button-registry");